var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.721,
    height: 37.889,
    viewBox: "0 0 43.721 37.889",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19452",
    "data-name": "Group 19452",
    transform: "translate(-16457.162 -517.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18488",
    "data-name": "Group 18488",
    transform: "translate(16457.162 517.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_96615_cc-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16692",
    "data-name": "Group 16692",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9702",
    "data-name": "Path 9702",
    d: "M18.171,43.77a6.462,6.462,0,0,0,9.276,0L41.214,29.441a13.068,13.068,0,0,0,0-17.893,11.72,11.72,0,0,0-17.1,0l-1.225,1.262-1.211-1.262a11.72,11.72,0,0,0-17.1,0,13.065,13.065,0,0,0,0,17.891Zm0,0",
    transform: "translate(-1.036 -7.844)",
    fill: "#fc7b7b"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.5d53de54.svg";
export { ForwardRef as ReactComponent };